(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["policy-page-enhancements"] && !Shopify.designMode) return;
  try {
    (function () {
    var policyPaths = [
      '/pages/policies',
      '/policies/refund-policy',
      '/pages/sms-messaging-compliance-policy',
      '/policies/privacy-policy',
      '/policies/terms-of-service'
    ];

    function createAccordion(title, contentNodes, isOpen) {
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var content = document.createElement('div');
      details.className = 'agc-policy-accordion';
      details.open = isOpen;
      summary.textContent = title;
      content.className = 'agc-policy-accordion__content';

      for (var i = 0; i < contentNodes.length; i += 1) {
        content.appendChild(contentNodes[i]);
      }

      details.appendChild(summary);
      details.appendChild(content);
      return details;
    }

    function addPolicyNavigation(path) {
      var existing = document.querySelector('#MainContent .agc-policy-nav');
      if (existing) return;

      var container = document.querySelector('.shopify-policy__container');
      var title = container && container.querySelector('.shopify-policy__title');
      var template = document.getElementById('agc-policy-nav-template');
      if (!container || !title || !template) return;

      var nav = template.content.firstElementChild.cloneNode(true);
      var links = nav.querySelectorAll('a');

      for (var i = 0; i < links.length; i += 1) {
        if (links[i].getAttribute('href') === path) {
          links[i].setAttribute('aria-current', 'page');
        }
      }

      title.insertAdjacentElement('afterend', nav);
    }

    function enhanceTerms() {
      var root = document.querySelector('.shopify-policy__body > .rte');
      if (!root || root.querySelector('.agc-policy-accordion-list')) return;

      var headings = Array.prototype.slice.call(root.querySelectorAll('h2'));
      var sections = [];

      for (var i = 0; i < headings.length; i += 1) {
        var parent = headings[i].parentElement;
        if (
          parent &&
          parent.tagName === 'DIV' &&
          parent.querySelectorAll(':scope > h2').length === 1 &&
          sections.indexOf(parent) === -1
        ) {
          sections.push(parent);
        }
      }

      if (sections.length < 3) return;

      var list = document.createElement('div');
      list.className = 'agc-policy-accordion-list';
      sections[0].parentNode.insertBefore(list, sections[0]);

      for (var j = 0; j < sections.length; j += 1) {
        var heading = sections[j].querySelector(':scope > h2');
        var nodes = Array.prototype.slice.call(sections[j].childNodes);
        var contentNodes = [];

        for (var k = 0; k < nodes.length; k += 1) {
          if (nodes[k] !== heading) contentNodes.push(nodes[k]);
        }

        list.appendChild(
          createAccordion(heading.textContent.trim(), contentNodes, j === 0)
        );
        sections[j].remove();
      }
    }

    function enhanceSms() {
      var section = document.querySelector('.sms-policy');
      if (!section || section.querySelector('.agc-policy-accordion-list')) return;

      var headings = Array.prototype.slice.call(
        section.querySelectorAll(':scope > h2')
      );
      if (headings.length < 3) return;

      var list = document.createElement('div');
      list.className = 'agc-policy-accordion-list';
      section.insertBefore(list, headings[0]);

      for (var i = 0; i < headings.length; i += 1) {
        var heading = headings[i];
        var nodes = [];
        var node = heading.nextSibling;

        while (
          node &&
          !(node.nodeType === 1 && node.tagName === 'H2')
        ) {
          var next = node.nextSibling;
          if (!(node.nodeType === 1 && node.tagName === 'HR')) {
            nodes.push(node);
          } else {
            node.remove();
          }
          node = next;
        }

        list.appendChild(
          createAccordion(heading.textContent.trim(), nodes, i === 0)
        );
        heading.remove();
      }
    }

    function initializePolicyEnhancements() {
      var path = window.location.pathname.replace(/\/+$/, '') || '/';
      if (policyPaths.indexOf(path) === -1) return;

      addPolicyNavigation(path);
      if (path === '/policies/terms-of-service') enhanceTerms();
      if (path === '/pages/sms-messaging-compliance-policy') enhanceSms();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializePolicyEnhancements);
    } else {
      initializePolicyEnhancements();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
